import { AuditTabView } from "@/features/S2Dashboard";

export default function AuditPage() {
  return <AuditTabView />;
}
